module.exports = __webpack_public_path__ + "assets/wheel-respin.a71ba6a3a35cf27a54cda864360aac75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wheel-respin.png
// module id = 48
// module chunks = 0